'use client';

import React__default from 'react';

var IconClose2 = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 32 : _b, _c = _a.height, height = _c === void 0 ? 32 : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    return (React__default.createElement("svg", { width: width, height: height, className: className, viewBox: '0 0 32 32' },
        React__default.createElement("g", { id: 'icons/nav/icon-close-outline/size-m', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
            React__default.createElement("g", { id: 'icons8-delete', transform: 'translate(4.000000, 4.000000)', fill: '#555555', fillRule: 'nonzero' },
                React__default.createElement("polygon", { id: 'Path', points: '1.08552632 0.177631579 0.177631579 1.08552632 11.0921053 12 0.177631579 22.9144737 1.08552632 23.8223684 12 12.9078947 22.9144737 23.8223684 23.8223684 22.9144737 12.9078947 12 23.8223684 1.08552632 22.9144737 0.177631579 12 11.0921053' })))));
};

export { IconClose2 as default };
//# sourceMappingURL=IconClose2.js.map
